import { render, staticRenderFns } from "./players-data-list.vue?vue&type=template&id=de460716&"
import script from "./players-data-list.vue?vue&type=script&lang=js&"
export * from "./players-data-list.vue?vue&type=script&lang=js&"
import style0 from "./players-data-list.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "players-data-list.vue"
export default component.exports